import pro1 from "../asets/olx.jpg"
import pro2 from "../asets/netflix.png"
import pro3 from "../asets/website.png"
const ProjectCardData = [
    {
        imgsrc:pro1,
        title:"Ecommerce Website Design",
        text:"Olx clone website using React.js",
        view:"",
        source:""
    },

    {
        imgsrc:pro2,
        title:"Netflix Website Design",
        text:"Netlix clone website using React.js",
        view:"",
        source:""
    },

    {
        imgsrc:pro3,
        title:"Profile Website Design",
        text:"Javascript portfolio Website using HTML CSS Javascript React",
        view:"",
        source:""
    }
]
export default ProjectCardData;